import React, { Fragment } from 'react';
import axios from 'axios';
import { Button, Form, Input, Segment, Grid, TextArea } from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import { DateTimePicker } from 'react-widgets';
import moment from 'moment';


const mandatoryList = [
    {
        key: 1,
        value: 1,
        text: 'obavezni'
    },
    {
        key: 2,
        value: 2,
        text: 'izborni'
    }
];

class EditGrade extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            marks: this.props.marks,
            courseName: this.props.marks.courseName,
            code: this.props.marks.code,
            lectureNumber: this.props.marks.lectureNumber,
            exerciseNumber: this.props.marks.exerciseNumber,
            date: moment(this.props.marks.date).format('D. M. YYYY.'),
            newDate: new Date(this.props.marks.date),
            grade: this.props.marks.mark.id,
            ects: this.props.marks.ects,
            mandatory: this.props.marks.mandatory,
            courseNameEn: this.props.marks.translations.filter((e) => e.language === 'en')[0] ? this.props.marks.translations.filter((e) => e.language === 'en')[0].courseName : null,
            // courseNameOther: this.props.marks.translations.filter((e) => e.language !== 'en')[0] ? this.props.marks.translations.filter((e) => e.language !== 'en')[0].courseName : null,
            courseNameOther: this.props.marks.translations.filter((e) => e.language !== 'en')[0] ? this.props.marks.translations.filter((e) => e.language !== 'en')[0].courseName : this.props.marks.translations.filter((e) => e.language === 'en' && JSON.parse(localStorage.getItem('mob')).translations.find((f) => f.originalLanguage === true && f.language === 'en'))[0] ? this.props.marks.translations.filter((e) => e.language === 'en' && JSON.parse(localStorage.getItem('mob')).translations.find((f) => f.originalLanguage === true && f.language === 'en'))[0].courseName : null,
            otherLangOptions: [],
            comment: this.props.marks.comment,
            // otherLang: localStorage.getItem('mob').translations.filter((e) => e.originalLanguage === true)[0] ? localStorage.getItem('mob').translations.filter((e) => e.originalLanguage === true)[0].language : null,
            otherLang: JSON.parse(localStorage.getItem('mob')).translations.filter((e) => e.originalLanguage === true)[0] ? JSON.parse(localStorage.getItem('mob')).translations.filter((e) => e.originalLanguage === true)[0].language : null,


            ectsErr: false,
            codeErr: false,
            typeErr: false,
            dateErr: false,
            lectureNumberErr: false,
            exerciseNumberErr: false,
            courseNameErr: false,
            courseNameEnErr: false,
            courseNameOtherErr: false,
            otherLangErr: false,
            gradeErr: false,
            edit: false,

        };
        this.editMark = this.editMark.bind(this);
        this.closeEditMode = this.closeEditMode.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.fetchLangOptions = this.fetchLangOptions.bind(this);
        this.fetchMarkOptions = this.fetchMarkOptions.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        this.fetchMarkOptions();
        this.fetchLangOptions();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.marks !== this.state.marks) {
            console.log(prevProps);
            console.log(prevState);
            this.fetchMarkOptions();
            this.fetchLangOptions();
            this.setState({
                marks: this.props.marks,
                courseName: this.props.marks.courseName,
                code: this.props.marks.code,
                lectureNumber: this.props.marks.lectureNumber,
                exerciseNumber: this.props.marks.exerciseNumber,
                date: moment(this.props.marks.date).format('D. M. YYYY.'),
                newDate: new Date(this.props.marks.date),
                grade: this.props.marks.mark.id,
                ects: this.props.marks.ects,
                mandatory: this.props.marks.mandatory,
                courseNameEn: this.props.marks.translations.filter((e) => e.language === 'en')[0] ? this.props.marks.translations.filter((e) => e.language === 'en')[0].courseName : null,
                courseNameOther: this.props.marks.translations.filter((e) => e.language !== 'en')[0] ? this.props.marks.translations.filter((e) => e.language !== 'en')[0].courseName : this.props.marks.translations.filter((e) => e.language === 'en' && JSON.parse(localStorage.getItem('mob')).translations.find((f) => f.originalLanguage === true && f.language === 'en'))[0] ? this.props.marks.translations.filter((e) => e.language === 'en' && JSON.parse(localStorage.getItem('mob')).translations.find((f) => f.originalLanguage === true && f.language === 'en'))[0].courseName : null,
                // courseNameOther: this.props.marks.translations.filter((e) => e.language !== 'en')[0] ? this.props.marks.translations.filter((e) => e.language !== 'en')[0].courseName : null,
                otherLangOptions: [],
                comment: this.props.marks.comment,
                otherLang: JSON.parse(localStorage.getItem('mob')).translations.filter((e) => e.originalLanguage === true)[0] ? JSON.parse(localStorage.getItem('mob')).translations.filter((e) => e.originalLanguage === true)[0].language : null,
                // otherLang: this.props.marks.translations.filter((e) => e.language !== 'en')[0] ? this.props.marks.translations.filter((e) => e.language !== 'en')[0].language : null,

            });
        }
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    fetchLangOptions() {
        axios.get('/languages')
            .then(res => {
                this.setState({
                    otherLangOptions: res.data.map(el => ({
                        key: el.twoLetterCode,
                        value: el.twoLetterCode,
                        text: el.name
                    }))
                });
            });
    }

    fetchMarkOptions() {
        axios.get('/marks')
            .then(res => {
                this.setState({
                    markOptions: res.data.map(el => ({
                        key: el.id, value: el.id, text: el.displayName
                    }))
                });
            });
    }

    handleDateChange(name, date) {
        this.setState({
            [name]: date
        });
    }

    closeEditMode() {
        this.props.closeEditMode();
    }

    editMark(
        courseName,
        code,
        lectureNumber,
        exerciseNumber,
        date,
        ects,
        mark,
        mandatory
    ) {
        if (!this.state.courseName || !this.state.code || !this.state.lectureNumber || !this.state.exerciseNumber
            || !this.state.ects || !this.state.grade || !this.state.date
            || (!this.state.courseNameEn && !this.state.courseNameOther && !this.state.otherLang)
            || (this.state.courseNameEn && this.state.courseNameOther && !this.state.otherLang)
            || (!this.state.courseNameEn && this.state.courseNameOther && !this.state.otherLang)) {
            if (!this.state.courseNameEn && !this.state.courseNameOther) {
                toast('Niste unijeli sve podatke. Unesite barem jedan prevod za predmet.');
            } else { toast('Niste unijeli sve podatke'); }
            if (!this.state.courseName) { this.setState({ courseNameErr: true }); } else { this.setState({ courseNameErr: false }); }
            if (!this.state.code) { this.setState({ codeErr: true }); } else { this.setState({ codeErr: false }); }
            if (!this.state.lectureNumber) { this.setState({ lectureNumberErr: true }); } else { this.setState({ lectureNumberErr: false }); }
            if (!this.state.exerciseNumber) { this.setState({ exerciseNumberErr: true }); } else { this.setState({ exerciseNumberErr: false }); }
            if (!this.state.ects) { this.setState({ ectsErr: true }); } else { this.setState({ ectsErr: false }); }
            if (!this.state.grade) { this.setState({ gradeErr: true }); } else { this.setState({ gradeErr: false }); }
            if (!this.state.date) { this.setState({ dateErr: true }); } else { this.setState({ dateErr: false }); }
            if (!this.state.courseNameEn && !this.state.courseNameOther && !this.state.otherLang) { this.setState({ courseNameEnErr: true, courseNameOtherErr: true, otherLangErr: true }); } else { this.setState({ courseNameEnErr: false, courseNameOtherErr: false, otherLangErr: false }); }
            if (!this.state.courseNameEn && !this.state.courseNameOther && this.state.otherLang) { this.setState({ courseNameOtherErr: true }); }
            if (!this.state.courseNameEn && this.state.courseNameOther && !this.state.otherLang) { this.setState({ otherLangErr: true }); }
            if (this.state.courseNameOther && !this.state.otherLang) { this.setState({ otherLangErr: true }); }
            if (!this.state.courseNameOther && this.state.otherLang) { this.setState({ courseNameOtherErr: true }); }
        } else {
            let optLock = this.props.marks.optLock;
            let id = this.props.marks.id;
            let translations = [];
            if (this.state.courseNameEn && this.state.otherLang !== 'en') {
                translations.push({
                    language: { twoLetterCode: (this.state.otherLangOptions.filter((e) => e.value === 'en') ? this.state.otherLangOptions.find((e) => e.value === 'en').value : null) },
                    // language: { twoLetterCode: 'en' },
                    courseName: this.state.courseNameEn
                });
            }
            if (this.state.courseNameOther) {
                translations.push({
                    language: { twoLetterCode: this.state.otherLang },
                    courseName: this.state.courseNameOther
                });
            }

            let createMarkObj = {
                courseName,
                code,
                optLock,
                id,
                lectureNumber,
                exerciseNumber,
                date: this.state.newDate,
                ects,
                mark: { id: this.state.grade },
                mandatory: this.state.mandatory === 2 ? 0 : this.state.mandatory === 1 ? 1 : null,
                translations: [...translations]

            };

            axios.put('student-mobility-mark/edit/', { ...createMarkObj })
                .then(res => {
                    toast('Izmjena predmeta je uspješno izvršena.');
                    this.props.getMobilityMark();
                    this.props.closeEditMode();
                })
                .catch(err => {
                    toast('Došlo je do greške! Izmjena predmeta nije uspjela.');
                });
        }
    }

    render() {
        console.log('vvv', JSON.parse(localStorage.getItem('mob')).translations.filter((e) => e.originalLanguage === true)[0].language);
        return (
            <Fragment>
                <Segment secondary clearing>
                    <Form noValidate>
                        <Grid columns={2} centered className="stackable">
                            <Grid.Row stretched>
                                <Grid.Column>
                                    <Form.Field
                                        required
                                        error={this.state.courseNameErr}
                                        control={Input}
                                        label="Predmet (B/H/S)"
                                        value={this.state.courseName}
                                        onChange={(e) => this.setState({ courseName: e.target.value })}
                                        name="courseName"
                                        placeholder="Unesite naziv predmeta"
                                    />
                                    <Form.Field
                                        control={Input}
                                        label="Predmet (engleski jezik)"
                                        value={this.state.courseNameEn}
                                        onChange={(e) => this.setState({ courseNameEn: e.target.value })}
                                        name="courseNameEn"
                                        placeholder="Unesite naziv predmeta"
                                        error={this.state.courseNameEnErr}
                                        disabled={this.state.otherLang === 'en'}
                                    />
                                </Grid.Column>
                                <Grid.Column>
                                    <Segment>
                                        <Form.Field error={this.state.otherLangErr}>
                                            <label>Izvorni jezik</label>
                                            <Form.Dropdown
                                                clearable
                                                selection
                                                placeholder="Odaberite izvorni jezik"
                                                value={this.state.otherLang}
                                                onChange={this.handleInputChange}
                                                name="otherLang"
                                                options={this.state.otherLangOptions.filter((e) => (e.value !== 'bs'))}
                                                search
                                                fluid
                                            />
                                        </Form.Field>
                                        <Form.Field
                                            control={Input}
                                            label="Predmet (izvorni jezik)"
                                            value={this.state.courseNameOther}
                                            onChange={(e) => this.setState({ courseNameOther: e.target.value })}
                                            name="courseNameOther"
                                            placeholder="Unesite naziv predmeta"
                                            error={this.state.courseNameOtherErr}
                                        />
                                    </Segment>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                        <Grid columns={4} centered className="stackable">
                            <Grid.Row stretched>
                                <Grid.Column>
                                    <Form.Field
                                        required
                                        error={this.state.codeErr}
                                        control={Input}
                                        label="Šifra predmeta"
                                        value={this.state.code}
                                        onChange={(e) => this.setState({ code: e.target.value })}
                                        name="code"
                                        placeholder="Unesite šifru"
                                    />
                                    <Form.Field />
                                </Grid.Column>
                                <Grid.Column>
                                    <Form.Field
                                        required
                                        error={this.state.lectureNumberErr}
                                        control={Input}
                                        label="Broj predavanja"
                                        type="number"
                                        value={this.state.lectureNumber}
                                        onChange={(e) => this.setState({ lectureNumber: e.target.value })}
                                        name="lectureNumber"
                                        placeholder="Unesite broj predavanja"
                                    />
                                </Grid.Column>
                                <Grid.Column>
                                    <Form.Field
                                        required
                                        error={this.state.exerciseNumberErr}
                                        control={Input}
                                        label="Broj vježbi"
                                        type="number"
                                        value={this.state.exerciseNumber}
                                        onChange={(e) => this.setState({ exerciseNumber: e.target.value })}
                                        name="exerciseNumber"
                                        placeholder="Unesite broj vježbi"
                                    />
                                </Grid.Column>
                                <Grid.Column>
                                    <Form.Field
                                        required
                                        error={this.state.ectsErr}
                                        control={Input}
                                        label="ECTS"
                                        type="float"
                                        value={this.state.ects}
                                        onChange={(e) => this.setState({ ects: e.target.value })}
                                        name="ects"
                                        placeholder="Unesite ects"
                                    />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                        <Grid columns={3} centered className="stackable">
                            <Grid.Row stretched>
                                <Grid.Column>
                                    <Form.Field
                                        required
                                        error={this.state.dateErr}
                                        control={DateTimePicker}
                                        label="Datum ocjene"
                                        placeholder="Unesite datum ocjene"
                                        format="D. M. YYYY."
                                        value={this.state.newDate}
                                        time={false}
                                        onChange={this.handleDateChange.bind(null, 'newDate')}
                                        style={{ borderWidth: '0px' }}
                                    />
                                </Grid.Column>
                                <Grid.Column>
                                    <Form.Field required error={this.state.gradeErr}>
                                        <label>Ocjena</label>
                                        <Form.Dropdown
                                            clearable
                                            selection
                                            placeholder="Odaberite ocjenu"
                                            value={this.state.grade}
                                            onChange={this.handleInputChange}
                                            name="grade"
                                            options={this.state.markOptions}
                                            search
                                            fluid
                                        />
                                    </Form.Field>
                                </Grid.Column>
                                <Grid.Column>
                                    <Form.Field error={this.state.typeErr}>
                                        <label>Tip predmeta</label>
                                        <Form.Dropdown
                                            clearable
                                            selection
                                            placeholder="Odaberite tip predmeta"
                                            value={this.state.mandatory}
                                            onChange={(e, v) => this.setState({ mandatory: v.value })}
                                            name="mandatory"
                                            options={mandatoryList}
                                            search
                                            fluid
                                        />
                                    </Form.Field>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                        <Grid columns={1} centered className="stackable">
                            <Grid.Row stretched>
                                <Grid.Column>
                                    <Form.Field
                                        label="Komentar"
                                        control={TextArea}
                                        name="comment"
                                        rows={1}
                                        value={this.state.comment}
                                        onChange={this.handleInputChange}
                                        placeholder="Unesite komentar..."
                                    />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                        <br />
                        <Button
                            color="blue"
                            basic="true"
                            floated="right"
                            onClick={this.props.closeEditMode}
                        >  Odustani
                        </Button>
                        <Button
                            color="blue"
                            floated="right"
                            onClick={() => this.editMark(
                                this.state.courseName,
                                this.state.code,
                                this.state.lectureNumber,
                                this.state.exerciseNumber,
                                this.state.newDate,
                                this.state.ects,
                                this.state.grade,
                                this.state.mandatory
                            )}

                        >  Sačuvaj izmjene
                        </Button>

                    </Form>
                    <ToastContainer hideProgressBar />
                    <br />
                </Segment>

            </Fragment>
        );
    }
}

export default EditGrade;



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/EditGrade.js